// API Service for online database
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = {
  async get(endpoint) {
    const res = await fetch(`${API_URL}${endpoint}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },
  
  async post(endpoint, data) {
    const res = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },
  
  async put(endpoint, data) {
    const res = await fetch(`${API_URL}${endpoint}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },
  
  async delete(endpoint) {
    const res = await fetch(`${API_URL}${endpoint}`, { method: 'DELETE' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  }
};

// ==================== DDR ====================
export const getAllDDR = async (filters = {}) => {
  let url = '/api/ddr';
  const params = new URLSearchParams();
  if (filters.search) params.append('search', filters.search);
  if (filters.data_da) params.append('data_da', filters.data_da);
  if (filters.data_a) params.append('data_a', filters.data_a);
  if (filters.tipo_produttore) params.append('tipo_produttore', filters.tipo_produttore);
  if (params.toString()) url += '?' + params.toString();
  return api.get(url);
};

export const getDDRById = async (id) => {
  return api.get(`/api/ddr/${id}`);
};

export const getNextDDRNumber = async (tipo = "produttore") => {
  return api.get(`/api/ddr/next-number?tipo=${tipo}`);
};

export const createDDR = async (ddrData) => {
  return api.post('/api/ddr', ddrData);
};

export const updateDDR = async (id, ddrData) => {
  return api.put(`/api/ddr/${id}`, ddrData);
};

export const deleteDDR = async (id) => {
  return api.delete(`/api/ddr/${id}`);
};

// ==================== DESTINATARI ====================
export const getAllDestinatari = async () => {
  return api.get('/api/destinatari');
};

export const createDestinatario = async (data) => {
  return api.post('/api/destinatari', data);
};

export const updateDestinatario = async (id, data) => {
  return api.put(`/api/destinatari/${id}`, data);
};

export const deleteDestinatario = async (id) => {
  return api.delete(`/api/destinatari/${id}`);
};

// ==================== DESTINATARI DDT ====================
export const getAllDestinatariDDT = async () => {
  return api.get('/api/destinatari-ddt');
};

export const createDestinatarioDDT = async (data) => {
  return api.post('/api/destinatari-ddt', data);
};

export const updateDestinatarioDDT = async (id, data) => {
  return api.put(`/api/destinatari-ddt/${id}`, data);
};

export const deleteDestinatarioDDT = async (id) => {
  return api.delete(`/api/destinatari-ddt/${id}`);
};

// ==================== PRODUTTORI ====================
export const getAllProduttori = async () => {
  return api.get('/api/produttori');
};

export const createProduttore = async (data) => {
  return api.post('/api/produttori', data);
};

export const updateProduttore = async (id, data) => {
  return api.put(`/api/produttori/${id}`, data);
};

export const deleteProduttore = async (id) => {
  return api.delete(`/api/produttori/${id}`);
};

// ==================== UBICAZIONI ====================
export const getAllUbicazioni = async () => {
  const data = await api.get('/api/ubicazioni');
  // Map to frontend format
  return data.map(u => ({
    ...u,
    nome_zona: u.codice || u.nome_zona,
    descrizione_zona: u.descrizione || u.descrizione_zona
  }));
};

export const createUbicazione = async (data) => {
  // Map to backend format
  const backendData = {
    codice: data.nome_zona || data.codice || '',
    descrizione: data.descrizione_zona || data.descrizione || ''
  };
  return api.post('/api/ubicazioni', backendData);
};

export const deleteUbicazione = async (id) => {
  return api.delete(`/api/ubicazioni/${id}`);
};

// ==================== CAUSALI ====================
export const getAllCausali = async () => {
  return api.get('/api/causali');
};

export const createCausale = async (data) => {
  return api.post('/api/causali', data);
};

export const updateCausale = async (id, data) => {
  return api.put(`/api/causali/${id}`, data);
};

export const deleteCausale = async (id) => {
  return api.delete(`/api/causali/${id}`);
};

// ==================== SPECIES ====================
export const getAllSpecies = async () => {
  return api.get('/api/species');
};

export const createSpecie = async (data) => {
  return api.post('/api/species', data);
};

export const updateSpecie = async (id, data) => {
  return api.put(`/api/species/${id}`, data);
};

export const deleteSpecie = async (id) => {
  return api.delete(`/api/species/${id}`);
};

// ==================== SETTINGS ====================
export const getSettings = async () => {
  const settings = await api.get('/api/settings');
  // Get firma separately
  try {
    const firma = await api.get('/api/firma');
    settings.firma_immagine = firma.image || '';
  } catch (e) {
    settings.firma_immagine = '';
  }
  return settings;
};

export const updateSettings = async (data) => {
  // Handle firma separately
  if (data.firma_immagine !== undefined) {
    await api.put('/api/firma', { image: data.firma_immagine });
    const { firma_immagine, ...rest } = data;
    if (Object.keys(rest).length > 0) {
      return api.put('/api/settings', rest);
    }
    return { success: true };
  }
  return api.put('/api/settings', data);
};

// ==================== STATS ====================
export const getStats = async () => {
  const stats = await api.get('/api/stats');
  const destinatari = await api.get('/api/destinatari');
  const produttori = await api.get('/api/produttori');
  
  return {
    total_ddr: stats.total_ddr || 0,
    total_destinatari: destinatari.length || 0,
    total_produttori: produttori.length || 0,
    this_month_ddr: stats.this_month || 0,
    total_weight: stats.total_weight || 0
  };
};

export const getReport = async (anno) => {
  const url = anno ? `/api/report?anno=${anno}` : '/api/report';
  return api.get(url);
};

// ==================== ULTIMO DDR ====================
export const getLastDDR = async () => {
  try {
    return await api.get('/api/ddr-ultimo');
  } catch (e) {
    return null;
  }
};

// ==================== BACKUP / IMPORT ====================
export const importBackup = async (backupData) => {
  return api.post('/api/import-backup', backupData);
};

// Export backup (download from current DB)
export const downloadBackup = async () => {
  const [ddr, destinatari, produttori, ubicazioni, species, settings, causali] = await Promise.all([
    api.get('/api/ddr'),
    api.get('/api/destinatari'),
    api.get('/api/produttori'),
    api.get('/api/ubicazioni'),
    api.get('/api/species'),
    api.get('/api/settings'),
    api.get('/api/causali')
  ]);
  
  const backup = {
    version: 1,
    exportDate: new Date().toISOString(),
    data: { ddr, destinatari, produttori, ubicazioni, species, settings: [settings], causali }
  };
  
  const jsonStr = JSON.stringify(backup, null, 2);
  const blob = new Blob([jsonStr], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `RMDDR_backup_${new Date().toISOString().split('T')[0]}.json`;
  link.click();
  URL.revokeObjectURL(url);
  
  return { success: true };
};

// Initialize (no-op for online mode)
export const initializeDB = async () => {
  return true;
};

export default api;
